import useCopilotAccountOwnerId from 'components/CopilotControl/hooks/useCopilotAccountOwnerId'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import {
  useFetchPatientsSentimentAggregationQuery,
  useFetchPatientsSentimentDataInfiniteQuery
} from 'store/modules/CopilotControl'
import PatientsList from '../../common/PatientsList/PatientsList'
import PatientsSentimentHeaderSkeleton from './PatientsSentimentHeaderSkeleton'
import PatientsSentimentListHeader from './PatientsSentimentListHeader'
import PatientsSentimentListItem from './PatientsSentimentListItem'
import PatientsListError from '../PatientsListError'
import useEngagementsWidget from '../../common/EngagementWidget/useEngagementsWidget'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'

const PatientsSentimentList = () => {
  const accountOwnerId = useCopilotAccountOwnerId()
  const { isStatusesLoading } = useCopilotPatientsList()
  const [selectedCategories, setSelectedCategories] = useState([])

  const { data: sentimentData = {}, isLoading: isLoadingAggregations } = useFetchPatientsSentimentAggregationQuery(
    { accountOwnerId },
    { skip: !accountOwnerId }
  )

  const {
    data: patients = [],
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage
  } = useFetchPatientsSentimentDataInfiniteQuery(
    {
      accountOwnerId,
      categories: selectedCategories
    },
    {
      skip: !accountOwnerId
    }
  )

  const { scoreOptions } = useEngagementsWidget({
    engagementType: CopilotEngagementTypes.PatientsSentiment,
    values: sentimentData
  })

  const patientsPaginatedData = useMemo(() => {
    return patients.pages?.map(page => page.items).flat() || []
  }, [patients])

  const hasMorePages = useMemo(() => _.last(patients?.pages || [])?.hasMore, [patients])

  const isListLoading = useMemo(
    () => isLoading || isStatusesLoading || isFetching,
    [isLoading, isFetching, isStatusesLoading]
  )

  return (
    <PatientsList
      isHeaderLoading={isLoadingAggregations}
      isListLoading={isListLoading && !isFetchingNextPage}
      isEmpty={false}
      fetchNextPage={fetchNextPage}
      hasMorePages={hasMorePages}
      patients={patientsPaginatedData}
      EmptyStateComponent={<PatientsListError />}
      HeaderSkeletonComponent={<PatientsSentimentHeaderSkeleton />}
      scoreOptions={scoreOptions}
      PatientsHeaderComponent={
        <PatientsSentimentListHeader
          scoreOptions={scoreOptions}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
        />
      }
      PatientListItemComponent={PatientsSentimentListItem}
    />
  )
}

export default PatientsSentimentList
